import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Page} from '../../moderator/components/add-edit-page/model/page';

@Injectable()
export class PagesServiceShared {
  constructor(private _http: HttpClient) {
  }

  getPageContent(pageId: number) {
    return this._http.post<Page>('api/s/pages/get', pageId);
  }

  getPageImage(pageId: number, fileId: string) {
    return this._http.get(`api/s/pages/getImage/${pageId}/${fileId}`, {responseType: 'blob'});
  }

  searchText(params) {
    return this._http.post<any>('api/s/pages/search', params);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/services/pages-shared.service.ts